export enum StepId {
  HomeAddressStep = "home-address-step",
  HomeMapStep = "home-map-step",
  SelectSettingsProfileStep = "settings-profile-step",
}
